import React, { useState, useEffect } from 'react';
import { Col, Row, Form, Card, Button, Accordion, Tab, Tabs } from 'react-bootstrap';
import { Document, Page, pdfjs } from 'react-pdf';
import CSSLoader from '../../../shared/cssLoader';
import styles from './customQuestion.module.scss';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

const CandidateAnswersToCustomQuestionsView = (props) => {

    return (
        <div>

            <div className="mt-3">
                <Card className={styles.viewCard}>
                    <Card.Header className={styles.cardHeader}>
                        <div className={styles.headerDetails}>
                            <p className={styles.accordianHeaderTopic}>Answers to Custom Questions&nbsp;&nbsp;</p>
                        </div>
                    </Card.Header>
                    <Card.Body className={styles.cvViewBody}>
                        {
                            props.candidateValues.custom_question_answers && props.candidateValues.custom_question_answers.map((values, index) => (
                                <Row className='mb-3'>
                                    <Col className="text-left">
                                        <p className={styles.customQuestion}>{index + 1}.&nbsp;{values.question} ?</p>
                                        <p className={styles.customQuestionAnswer}>{values.answer}</p>
                                    </Col>
                                </Row>
                            ))
                        }
                    </Card.Body>
                </Card>
            </div>
        </div>
    )
}

export default CandidateAnswersToCustomQuestionsView